var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49996 13.4752L4.60829 10.5835C4.45248 10.4277 4.24115 10.3402 4.02079 10.3402C3.80044 10.3402 3.58911 10.4277 3.43329 10.5835C3.27748 10.7393 3.18994 10.9507 3.18994 11.171C3.18994 11.2801 3.21143 11.3882 3.25319 11.489C3.29494 11.5898 3.35614 11.6814 3.43329 11.7585L6.91663 15.2419C7.24163 15.5669 7.76663 15.5669 8.09163 15.2419L16.9083 6.42519C17.0641 6.26937 17.1516 6.05804 17.1516 5.83769C17.1516 5.61733 17.0641 5.406 16.9083 5.25019C16.7525 5.09437 16.5411 5.00684 16.3208 5.00684C16.1004 5.00684 15.8891 5.09437 15.7333 5.25019L7.49996 13.4752Z",
    fill: "#0B7CDA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check-mark.dc7e2ffaaa79d4dfdfe42e3df295d876.svg";
export { ForwardRef as ReactComponent };